import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { doc, onSnapshot, collection, query, where, orderBy, limit } from 'firebase/firestore';

const GOLD = '#B8860B';

/**
 * Professional Naira Formatter Utility
 */
const formatNaira = (amount) => {
  if (amount === undefined || amount === null) return "₦0.00";
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 2,
  }).format(amount).replace('NGN', '₦');
};

export default function StylistFinances() {
  const [balance, setBalance] = useState(0);
  const [totalEarned, setTotalEarned] = useState(0);
  const [recentPayouts, setRecentPayouts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const stylistRef = doc(db, 'barbers', user.uid);
    const unsubStylist = onSnapshot(stylistRef, (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setBalance(data.walletBalance || 0);
        setTotalEarned(data.totalEarnings || 0);
      }
      setLoading(false);
    });

    const payoutsQuery = query(
      collection(db, 'bookings'),
      where('stylistId', '==', user.uid),
      where('escrowStatus', 'in', ['released_automatically', 'released_manually']),
      orderBy('payoutCompletedAt', 'desc'),
      limit(10)
    );

    const unsubPayouts = onSnapshot(payoutsQuery, (snap) => {
      const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setRecentPayouts(docs);
    });

    return () => {
      unsubStylist();
      unsubPayouts();
    };
  }, []);

  if (loading) return <div style={{ color: GOLD, textAlign: 'center', padding: '20px' }}>Loading Finances...</div>;

  return (
    <div style={containerStyle}>
      <h2 style={{ color: GOLD, borderBottom: `1px solid ${GOLD}`, paddingBottom: '10px' }}>
        Financial Overview
      </h2>

      <div style={statsGrid}>
        <div style={cardStyle}>
          <p style={labelStyle}>Wallet Balance</p>
          <h3 style={valueStyle}>{formatNaira(balance)}</h3>
          <button style={payoutBtn}>Request Payout</button>
        </div>

        <div style={cardStyle}>
          <p style={labelStyle}>Lifetime Earnings</p>
          <h3 style={valueStyle}>{formatNaira(totalEarned)}</h3>
        </div>
      </div>

      <h3 style={{ color: GOLD, marginTop: '30px' }}>Recent Payouts</h3>
      <div style={listContainer}>
        {recentPayouts.length === 0 ? (
          <p style={{ opacity: 0.5 }}>No recent payouts found.</p>
        ) : (
          recentPayouts.map((p) => (
            <div key={p.id} style={listItem}>
              <div>
                <div style={{ fontWeight: 'bold' }}>{p.serviceName || 'Haircut Service'}</div>
                <div style={{ fontSize: '0.8rem', opacity: 0.6 }}>
                  {p.payoutCompletedAt?.toDate().toLocaleDateString()}
                </div>
              </div>
              <div style={{ color: '#4CAF50', fontWeight: 'bold' }}>
                +{formatNaira(p.stylistNet || 0)}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

// Styles
const containerStyle = { padding: '20px', background: '#001F3F', minHeight: '100vh', color: 'white' };
const statsGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '20px' };
const cardStyle = { background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '15px', border: '1px solid rgba(184, 134, 11, 0.3)' };
const labelStyle = { fontSize: '0.8rem', opacity: 0.7, marginBottom: '5px' };
const valueStyle = { fontSize: '1.5rem', fontWeight: 'bold', margin: '0' };
const payoutBtn = { marginTop: '15px', width: '100%', padding: '8px', background: GOLD, border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' };
const listContainer = { marginTop: '15px' };
const listItem = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px', borderBottom: '1px solid rgba(255,255,255,0.1)' };
